import * as React from "react"
const Gaining = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={17}
    height={17}
    fill="none"
    {...props}
  >
    <path
   fill="#BDDEFF"
      fillOpacity={1}
      d="M3.75 8.063a4.312 4.312 0 1 1 8.625 0 4.312 4.312 0 0 1-8.625 0Z"
    />
    <path
     fill="#BDDEFF"
      fillOpacity={1}
      d="M8.063 1.466a6.597 6.597 0 1 0 6.563 5.936.733.733 0 1 1 1.46-.145 8.062 8.062 0 1 1-3.1-5.58 2.199 2.199 0 1 1-1.047 1.047 6.564 6.564 0 0 0-3.877-1.258Z"
    />
  </svg>
)
export default Gaining
